import MD5 from 'md5'

import { getOauthClient } from './oauth'

const getCookieLoggedName = () => {
  switch (process.env.REACT_APP_NODE_ENV) {
    case 'development':
      return 'development_shared_cookie'
    case 'local':
    case 'pull_request':
      if (process.env.REACT_APP_PR_ENVIRONMENT === 'staging') {
        return 'staging_shared_cookie'
      }
      return 'development_shared_cookie'

    case 'staging':
      return 'staging_shared_cookie'
    case 'production':
      return 'shared_cookie'
    default:
      return 'development_shared_cookie'
  }
}

const getToken = () => {
  const r = document.cookie.match(`\\b${getCookieLoggedName()}=([^;]*)\\b`)
  return r ? r[1] : undefined
}

function clearToken() {
  const cookies = document.cookie.split(';')
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i]
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.plurall.net`
  }
}

const getClient = () => {
  const r = document.cookie.match('\\buser_agent=([^;]*)\\b')
  return r ? r[1] : setClient()
}

function setClient() {
  const client = MD5(`client-side-${new Date().getTime()}`)
  document.cookie = `user_agent=${client};path=/;domain=.plurall.net`
  return client
}

function Logout(message) {
  clearToken()
  sessionStorage.clear()
  const redirectUrl = `${process.env.REACT_APP_PLURALL_LOGIN_URL}/logout`
  if (message) {
    window.location.href = `${redirectUrl}?error=${message}`
    return
  }
  window.location.href = redirectUrl
}

const setToken = token => {
  const sharedCookieName = getCookieLoggedName()
  document.cookie = `${sharedCookieName}=${token};path=/;domain=.plurall.net`
}

const clearExpiredProfileStorageKey = () => {
  Object.keys(sessionStorage).forEach(key => {
    if (/^user_profile_graphql_([0-9]+[:]+[0-9]+)_[A-Za-z0-9]+$/.test(key)) {
      sessionStorage.removeItem(key)
    }
  })
}

const redirectToHome = () => {
  window.location.assign(`${process.env.REACT_APP_PLURALL_HOME_URL}`)
}

const handleNotAuthenticated = path => {
  const OAuth = getOauthClient(path)
  const href = OAuth.token.getUri()
  window.location.href = href
  return null
}

export {
  getToken,
  clearToken,
  getClient,
  Logout,
  setToken,
  redirectToHome,
  handleNotAuthenticated,
  getCookieLoggedName,
  clearExpiredProfileStorageKey,
}
